import { translate } from 'src/app/project/features/translate/translate';
import { EPriority } from 'src/app/project/modules/points/priorities';
import { ISelectMultipleOptionPriority } from 'src/app/project/components/input/select-multiple/select-multiple.model';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

export function getAdvancedPriorityValues(): ISelectMultipleOptionPriority[] {
  return [
    {
      value: EPriority.HIGH,
      label: translate('high'),
      selected: false,
      iconSrc: EIconPath.ICON_BADGE_PRIORITY_HIGH_12,
    },
    {
      value: EPriority.MEDIUM,
      label: translate('medium'),
      selected: false,
      iconSrc: EIconPath.ICON_BADGE_PRIORITY_MEDIUM_12,
    },
    {
      value: EPriority.LOW,
      label: translate('low'),
      selected: false,
      iconSrc: EIconPath.ICON_BADGE_PRIORITY_LOW_12,
    },
  ];
}
